import React from 'react';
import './TrustBadge.css';

function TrustBadge({ variant = 'full' }) {
  if (variant === 'compact') {
    return (
      <div className="trust-badge-compact">
        <div className="trust-badge-icon">🔒</div>
        <div className="trust-badge-text">
          <strong>Privacy First</strong>
          <span>Your identity is protected</span>
        </div>
      </div>
    );
  }

  if (variant === 'banner') {
    return (
      <div className="trust-banner">
        <div className="trust-banner-header">
          <span className="trust-banner-icon">🛡️</span>
          <h3>Your Safety is Our Priority</h3>
        </div>
        <div className="trust-banner-features">
          <div className="trust-feature">
            <span className="feature-icon">🔒</span>
            <span>Anonymous by Default</span>
          </div>
          <div className="trust-feature">
            <span className="feature-icon">✅</span>
            <span>Email Verified</span>
          </div>
          <div className="trust-feature">
            <span className="feature-icon">🔐</span>
            <span>Encrypted Data</span>
          </div>
          <div className="trust-feature">
            <span className="feature-icon">👤</span>
            <span>You Control Privacy</span>
          </div>
        </div>
      </div>
    );
  }

  // Full variant - detailed trust information
  return (
    <div className="trust-badge-full">
      <div className="trust-badge-header">
        <span className="trust-shield">🛡️</span>
        <h3>Privacy-First Platform</h3>
        <p className="trust-tagline">Built for your safety and trust</p>
      </div>

      <div className="trust-features-grid">
        <div className="trust-feature-card">
          <div className="feature-icon-large">🔒</div>
          <h4>Anonymous Discovery</h4>
          <p>No names or photos visible until you choose to reveal them</p>
        </div>

        <div className="trust-feature-card">
          <div className="feature-icon-large">✅</div>
          <h4>Verified Users</h4>
          <p>Phone verification required. Email verification encouraged</p>
        </div>

        <div className="trust-feature-card">
          <div className="feature-icon-large">🔐</div>
          <h4>Encrypted Identities</h4>
          <p>Your sensitive identity information is encrypted and secure</p>
        </div>

        <div className="trust-feature-card">
          <div className="feature-icon-large">👤</div>
          <h4>You Control Privacy</h4>
          <p>4-level disclosure system. You decide what to share and when</p>
        </div>

        <div className="trust-feature-card">
          <div className="feature-icon-large">🚫</div>
          <h4>Report & Block</h4>
          <p>Instant blocking. Admin-reviewed reports. Zero tolerance policy</p>
        </div>

        <div className="trust-feature-card">
          <div className="feature-icon-large">⚖️</div>
          <h4>Trust Score System</h4>
          <p>Prevents spam and bad actors. Rewards genuine engagement</p>
        </div>
      </div>

      <div className="trust-commitment">
        <p>
          <strong>Our Commitment:</strong> We never sell your data. Your identity information 
          is never shared publicly. You have complete control over your privacy at all times.
        </p>
      </div>
    </div>
  );
}

export default TrustBadge;
